import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {StandardDays} from '../Model/StandardDays';

@Component({
  selector: 'app-standard-days',
  templateUrl: './standardDays.component.html',
  styleUrls: ['./standardDays.component.css']
})

export class StandardDaysComponent implements OnInit {
  standardDays: StandardDays;


  constructor(private dataService: DataService) {
    this.standardDays = {
      id: 0, person: null,
      monday: false, timeMonday: '1200',
      tuesday: false, timeTuesday: '1200',
      wednesday: false, timeWednesday: '1200',
      thursday: false, timeThursday: '1200',
      friday: false, timeFriday: '1200'
    };
  }

  /**
   * getStandardDays on init of the page
   */
  ngOnInit() {
    this.getStandardDays();
  }

  /**
   * on Change save the new standard days of the currently logged in {@link Person}
   */
  change() {
    console.log(this.standardDays);
    this.dataService.setStandardDays(this.standardDays).then((standardDays) => {
        this.standardDays = standardDays;
      }
    );
    console.log('change');
  }

  /**
   * get the standard days of the currently logged in {@link Person} and save it to the {@link standardDays} variable.
   */
  private getStandardDays(): void {
    this.dataService.getStandardDays().then( (standardDays) => {
      this.standardDays = standardDays;
    } );
  }
}



// WEBPACK FOOTER //
// ./src/app/standardDays/standardDays.component.ts